<script lang="ts">
  import { Activity, type Exercise } from '@/Common/ActivityFunctions';
  import { convertSeconds, formatXSSDetails, kmToMile, tidy } from '@/Util/utils';
  import { format } from 'date-fns';
  import { ActivityTag } from '@/Common/ActivityTag';
  import { TagWrapper } from '@/Common';
  import XSSDisplay from '../../Common/XSSDisplay.svelte';
  import { cn } from '@/lib/utils';
  import ExerciseDialog from './ExerciseDialog.svelte';
  import type { TodaysActivities } from '@/Common/constants';
  import TodayActivityCardActions from './TodayActivityCardActions.svelte';

  export let activity: Exercise;
  export let todaysActivities: TodaysActivities;
  export let isLoading = false;

  let detailsDialogOpen: boolean = false;
  let rootDiv: HTMLElement;
  
  //@ts-ignore
  const Xert = window.Xert;
  let useFreedomUnits: boolean = Xert._displayUnits == 'imperial';

  const activityTag = ActivityTag('small');
  $: activityTags = [
    activityTag.device(activity),
  ].filter((tag) => tag);

</script>

<div bind:this={rootDiv} class='flex flex-col gap-1 rounded border border-border p-2 text-sm'>
  <div class="flex flex-row flex-wrap items-center gap-2">
    <TagWrapper tags={activityTags} />
    <h3 class={cn("text-sm font-normal m-0", activity.is_currently_selected_duplicate ? 'font-semibold' : '')}>
      {#if Activity.getDetailsPageLink(activity)}
        <a class='hover:underline text-foreground' href={Activity.getDetailsPageLink(activity)} target={Activity.isActivity(activity) ? "activity" : "workout"}>
          {activity.name}
        </a>
      {:else}
        {activity.name}
      {/if}
    </h3>
  </div>
  <div class='flex flex-row flex-wrap items-center gap-2'>
    <div class="text-sm text-gray-500">{format(new Date(activity.start_date), 'hh:mm aa')}</div>
    <span class="text-sm text-gray-500">{tidy(useFreedomUnits ? kmToMile(activity.distance ?? 0) : (activity.distance ?? 0))} {useFreedomUnits ? 'mi' : 'km'}</span>
    <span class="text-sm text-gray-500">{convertSeconds(activity.duration ?? activity.adu)}</span>
    <span>
      XSS:
      <XSSDisplay
        xss={formatXSSDetails({
          xss: activity.xss ?? 0,
          xlss: activity.xlss ?? 0,
          xhss: activity.xhss ?? 0,
          xpss: activity.xpss ?? 0,
        })}
      />
    </span>
  </div>
  <TodayActivityCardActions {todaysActivities} {activity} bind:disabled={isLoading} />
</div>

<ExerciseDialog bind:open={detailsDialogOpen} exercise={activity} {todaysActivities} {rootDiv} />
